import React, { useCallback, useLayoutEffect, useState } from 'react';
import { WppBreadcrumb } from '@wppopen/components-library-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Localization } from 'utils';

export interface IBreadcrumbs {
    localization: Localization;
}

const initialBreadcrumb = [
    {
        label: 'Projections',
        path: 'us/projections',
        localization: Localization.US,
    },
    {
        label: 'Create Scenario',
        path: 'us/create_scenario',
        localization: Localization.US,
    },
];

export const Breadcrumbs = ({ localization }: IBreadcrumbs) => {
    const [breadcrumbData, setBreadcrumbData] = useState(initialBreadcrumb);

    const navigate = useNavigate();
    const location = useLocation();

    const handleRedirectTo = (value: any) => {
        const routePath = value.detail.path;
        navigate(routePath);
    };

    const handleBreadcrumpData = useCallback(() => {
        const filteredBreadcrumb = [
            ...initialBreadcrumb.filter((e: any) => e.localization.includes(localization)),
        ];

        const currentIndex = filteredBreadcrumb.findIndex((e: any) => e.path == location.pathname);

        const currentBreadcrumb = [
            ...filteredBreadcrumb.filter((e: any, i: number) => i <= currentIndex),
        ];
        setBreadcrumbData(currentBreadcrumb);
    }, [location.pathname, localization]);

    useLayoutEffect(() => {
        handleBreadcrumpData();

        return () => {
            setBreadcrumbData([]);
        };
    }, [handleBreadcrumpData, location.pathname]);

    return (
        <div>
            <WppBreadcrumb items={breadcrumbData} onWppChange={handleRedirectTo} />
        </div>
    );
};
